
export const mutations = {
  SET_MOCKED_CLIENT (state, mockedClient) {
    state.mockedClient = mockedClient;
  }
};
